import React from "react"

type IconProps = React.SVGProps<SVGSVGElement>

const ParkingIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16.5913 2.53846C16.5913 1.90131 16.0656 1.38478 15.4174 1.38462H2.58256C1.93424 1.38462 1.40867 1.90121 1.40867 2.53846V15.4615C1.40867 16.0988 1.93424 16.6154 2.58256 16.6154H15.4174C16.0656 16.6152 16.5913 16.0987 16.5913 15.4615V2.53846ZM18 15.4615C18 16.8634 16.8436 17.9998 15.4174 18H2.58256C1.15625 18 0 16.8635 0 15.4615V2.53846C0 1.13651 1.15625 0 2.58256 0H15.4174C16.8436 0.000161268 18 1.13661 18 2.53846V15.4615Z"
      fill="currentColor"
    />
    <path
      d="M6 13V5H9.14397C9.74838 5 10.2633 5.11589 10.6887 5.34766C11.1141 5.57682 11.4384 5.89583 11.6615 6.30469C11.8872 6.71094 12 7.17969 12 7.71094C12 8.24219 11.8859 8.71094 11.6576 9.11719C11.4293 9.52344 11.0986 9.83984 10.6654 10.0664C10.2348 10.293 9.71336 10.4062 9.10117 10.4062H7.09728V9.05078H8.82879C9.15305 9.05078 9.42023 8.99479 9.63035 8.88281C9.84306 8.76823 10.0013 8.61068 10.1051 8.41016C10.2114 8.20703 10.2646 7.97396 10.2646 7.71094C10.2646 7.44531 10.2114 7.21354 10.1051 7.01562C10.0013 6.8151 9.84306 6.66016 9.63035 6.55078C9.41764 6.4388 9.14786 6.38281 8.82101 6.38281H7.68482V13H6Z"
      fill="currentColor"
    />
  </svg>
)

export default ParkingIcon
